// ABOUTME: Read-only viewer modal for a warehouse relation news message.
// ABOUTME: Shows source logo, title, publish date, and the rendered tiptap body; carousel buttons when used as popup.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import UnpublishedIcon from "@mui/icons-material/Unpublished";

import { tokens } from "../../../../theme";
import SHModalBottom from "../../../theme/Modal/SHModalBottom";
import ReadOnlyTiptap from "../../../theme/chat/ReadOnlyTiptap";
import Text from "../../../theme/text/Text";
import Shbutton from "../../../theme/buttons/Shbutton";
import NewsCarouselButtons from "../MCreateNewsArticle/components/NewsCarouselButtons";

const formatDate = (raw, locale) => {
    if (!raw) return "";
    const d = raw instanceof Date ? raw : new Date(raw);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString(locale || "nl-NL", { day: "numeric", month: "long", year: "numeric" });
};

const MViewRelationNews = ({ open, handleClose, newsItem, logoUrl, onUnpublish, onNext, onBack, nextIsLast }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    if (!newsItem) return null;

    return (
        <SHModalBottom open={open} onClose={handleClose} maxWidth={720} centered>
            <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2, pb: (onUnpublish || onNext || onBack) ? 8 : 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            overflow: "hidden",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        }}
                    >
                        {logoUrl ? (
                            <Box component="img" src={logoUrl} alt="" sx={{ width: 1, height: 1, objectFit: "cover" }} />
                        ) : (
                            <WarehouseIcon sx={{ fontSize: 18, color: colors.txt["secondary"] }} />
                        )}
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ fontSize: 22, fontWeight: 900, fontFamily: "Roboto, sans-serif", color: colors.txt["primary"] }}>
                            {newsItem.title || t("untitled") || "Zonder titel"}
                        </Box>
                        <Text light fontSize={12}>{formatDate(newsItem.publishedAt, i18n.language)}</Text>
                    </Box>
                </Box>

                {newsItem.body && <ReadOnlyTiptap content={newsItem.body} colors={colors} />}
            </Box>

            {/* Floating unpublish button for published messages when the manager passes a handler */}
            {onUnpublish && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 24,
                        right: 24,
                        zIndex: 10,
                    }}
                >
                    <Shbutton
                        color="red"
                        variant="contained"
                        onClick={() => onUnpublish(newsItem)}
                        startIcon={<UnpublishedIcon />}
                    >
                        {t("unpublish")}
                    </Shbutton>
                </Box>
            )}

            <NewsCarouselButtons onNext={onNext} onBack={onBack} nextIsLast={nextIsLast} />
        </SHModalBottom>
    );
};

export default MViewRelationNews;
